import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  // FormControl,
  IconButton,
  // InputAdornment,
  // InputLabel,
  // OutlinedInput,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

const CopyTextField = ({
  onClickCopy,
  onClickCopyMessage,
  value,
  label,
  // fullWidth,
  // ...props
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  // const { translations } = useTranslations();
  // const i18n = translations.components.CopyTextField;

  const copyContent = () => {
    window.navigator.clipboard
      .writeText(value)
      .finally(() => enqueueSnackbar(onClickCopyMessage ?? 'messaggio'), {
        variant: 'success',
      });
  };

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: theme.palette.grey[400],
        borderRadius: 2,
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 40px',
        minHeight: 56,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        onClick={onClickCopy ?? copyContent}
        sx={{ cursor: 'pointer' }}
      >
        <IconButton size="small">
          <ContentCopyIcon fontSize="small" />
        </IconButton>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {label}
        </Typography>
      </Stack>
    </Box>
    // <FormControl fullWidth={fullWidth} variant="outlined">
    //   <OutlinedInput
    //     {...props}

    //     endAdornment={
    //       <InputAdornment position="end">
    //         <IconButton onClick={onClickCopy ?? copyContent} edge="end">
    //           <ContentCopyIcon width={20} height={20} />
    //         </IconButton>
    //       </InputAdornment>
    //     }
    //   />

    //   <InputLabel>{label}</InputLabel>
    // </FormControl>
  );
};

CopyTextField.propTypes = {
  onClickCopy: PropTypes.func,
  onClickCopyMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};

export { CopyTextField };
